import React, { useState } from 'react';
import { ScreenShell, Headline, Subtext } from '../components/ScreenShell';
import { TextField } from '../components/ui/Field';
import { PrimaryButton } from '../components/ui/PrimaryButton';
import type { PersonalizationProfile } from '../types/profile';
interface AccessScreenProps {
  profile: PersonalizationProfile;
  update: (patch: Partial<PersonalizationProfile>) => void;
  onSubmit: () => void;
}
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export function AccessScreen({
  profile,
  update,
  onSubmit
}: AccessScreenProps) {
  const [error, setError] = useState('');
  function handleSubmit(event: React.FormEvent) {
    event.preventDefault();
    if (!profile.parent_name.trim()) {
      setError('Escribe tu nombre para continuar.');
      return;
    }
    if (!EMAIL_PATTERN.test(profile.purchase_email.trim())) {
      setError('Revisa el correo que usaste en tu compra.');
      return;
    }
    setError('');
    onSubmit();
  }
  return <ScreenShell center data-id="element-54" data-mp="py57ot8cglwi">
      <div className="mb-8 text-center" data-id="element-55" data-mp="275jeovnpnw8g">
        <span className="inline-flex items-center gap-2 rounded-full border border-gold-200 bg-gold-200/40 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-gold-500" data-id="element-56" data-mp="274i7515wlrvh">
          Programa Mente Valiente
        </span>
        <div className="mt-6" data-id="element-57" data-mp="234hfgetsnk6h">
          <Headline data-id="element-58" data-mp="233oig5kn091j">Tu experiencia personalizada comienza aquí 💜</Headline>
          <Subtext data-id="element-59" data-mp="2qubr4t2dn2p5">
            Ingresa tus datos para comenzar a crear el programa de tu hijo o hija.
          </Subtext>
        </div>
      </div>

      <form onSubmit={handleSubmit} noValidate className="space-y-4" data-id="element-60" data-mp="2uv3zzl7c75kw">
        <TextField id="parent-name" label="Tu nombre" value={profile.parent_name} onChange={value => update({
        parent_name: value
      })} placeholder="Laura" autoComplete="given-name" data-id="element-61" data-mp="2gwnv7zt1bp5e" />
        <TextField id="purchase-email" label="Correo electrónico utilizado en la compra" type="email" inputMode="email" autoComplete="email" value={profile.purchase_email} onChange={value => update({
        purchase_email: value
      })} placeholder="laura@correo.com" data-id="element-62" data-mp="15isi0wloxqgt" />

        {error && <p role="alert" className="rounded-2xl bg-red-50 px-4 py-3 text-sm text-red-600" data-id="element-63" data-mp="hk2ufso9c16q">
            {error}
          </p>}

        <div className="pt-2" data-id="element-64" data-mp="ckgidmk60qzi">
          <PrimaryButton type="submit" data-id="element-65" data-mp="7npw2hhroz5n">Acceder a mi programa →</PrimaryButton>
        </div>
      </form>

      <p className="mt-4 text-center text-sm text-ink-muted" data-id="element-66" data-mp="2ntzh3bega04">
        Esto tomará solo unos minutos.
      </p>
    </ScreenShell>;
}